import { createRef, useMemo } from 'react';

export interface AnimationRefs {
  blobs: {
    pink: React.RefObject<HTMLDivElement | null>;
    cyan: React.RefObject<HTMLDivElement | null>;
  };
  texts: {
    hello: React.RefObject<HTMLDivElement | null>;
    prayerPre: React.RefObject<HTMLDivElement | null>;
  };
  universe: React.RefObject<HTMLDivElement | null>;
  prayer: {
    title: React.RefObject<HTMLDivElement | null>;
    container: React.RefObject<HTMLDivElement | null>;
    mainContainer: React.RefObject<HTMLDivElement | null>;
    content: React.RefObject<HTMLDivElement | null>;
    info: React.RefObject<HTMLDivElement | null>;
    encouragementMsgContainerRef: React.RefObject<HTMLDivElement | null>;
  };
  mainPrayer: {
    container: React.RefObject<HTMLDivElement | null>;
    listRef: React.RefObject<HTMLDivElement | null>;
  };
  buttons: {
    action: React.RefObject<HTMLButtonElement | null>;
    decor: React.RefObject<HTMLDivElement | null>;
    confirm: React.RefObject<HTMLButtonElement | null>;
  };
  glowCircle: React.RefObject<HTMLDivElement | null>;
  circle: React.RefObject<HTMLDivElement | null>;
  stars: React.RefObject<HTMLDivElement | null>[];
  pointsScreen: React.RefObject<HTMLDivElement | null>;
  container: React.RefObject<HTMLDivElement | null>;
}

export function useAnimationRefs(): AnimationRefs {
  return useMemo(
    () => ({
      blobs: {
        pink: createRef<HTMLDivElement>(),
        cyan: createRef<HTMLDivElement>(),
      },

      texts: {
        hello: createRef<HTMLDivElement>(),
        prayerPre: createRef<HTMLDivElement>(),
      },

      universe: createRef<HTMLDivElement>(),
      pointsScreen: createRef<HTMLDivElement>(),

      mainPrayer: {
        container: createRef<HTMLDivElement>(),
        listRef: createRef<HTMLDivElement>(),
      },

      prayer: {
        title: createRef<HTMLDivElement>(),
        container: createRef<HTMLDivElement>(),
        mainContainer: createRef<HTMLDivElement>(),
        content: createRef<HTMLDivElement>(),
        info: createRef<HTMLDivElement>(),
        encouragementMsgContainerRef: createRef<HTMLDivElement>(),
      },

      buttons: {
        action: createRef<HTMLButtonElement>(),
        decor: createRef<HTMLDivElement>(),
        confirm: createRef<HTMLButtonElement>(),
      },

      glowCircle: createRef<HTMLDivElement>(),
      circle: createRef<HTMLDivElement>(),

      stars: Array.from({ length: 7 }, () => createRef<HTMLDivElement>()),

      container: createRef<HTMLDivElement>(),
    }),
    []
  );
}
